import React from "react";
import PropTypes from "prop-types";
import { Avatar, AvatarGroup, Tooltip } from "@opendate-app/setlist";
import initialsFor from "./initials";
import personColorProps from "./personColor";

export default function AvatarStack({ people, max = 3, size = "sm", emptyLabel = "—" }) {
  if (!people || people.length === 0) return <span className="classes-text-secondary">{emptyLabel}</span>;
  const names = people.map((person) => person.name).join(", ");
  return (
    <Tooltip title={names}>
      <span className="d-inline-flex" role="img" aria-label={names}>
        <AvatarGroup size={size} max={max}>
          {people.map((person) => (
            <Avatar key={person.id ?? person.name} alt={person.name} src={person.src || undefined} initials={initialsFor(person.name)} {...personColorProps(person.name)} />
          ))}
        </AvatarGroup>
      </span>
    </Tooltip>
  );
}

AvatarStack.propTypes = {
  people: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string.isRequired,
    src: PropTypes.string,
  })),
  max: PropTypes.number,
  size: PropTypes.oneOf(["xs", "sm", "md"]),
  emptyLabel: PropTypes.node,
};
